import clsx from 'clsx';
import { useEffect, useState } from 'react';
import classes from './Clues.module.css';

import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';
import Button from '@/components/shared/Button/Button';
import { observer } from 'mobx-react-lite';
import Texts from 'react-sdk/Texts';

const Clues = ({clues, instance}) => {

  const [visibleClueIndex, setVisibleClueIndex] = useState(0);
  const [remainingTime, setRemainingTime] = useState(null);

  let clue = clues[visibleClueIndex]

  // affiche auto le nouvel indice
  useEffect(() => {
    setVisibleClueIndex(clues.length - 1)
  }, [clues]);


  // useEffect(() => {
  //   let timer
  //   /** @type {Clue} */
  //   let newClue = clues[clues.length -1]
  //   if(newClue.delay) {
  //     setRemainingTime(newClue.delay)
  //     timer = setInterval(() => {
  //       setRemainingTime(t => Math.max(t-1000, 0))
  //     }, 1000)
  //   }
  //   else {
  //     setRemainingTime(null)
  //   }


  //   return () => {
  //     clearInterval(timer)
  //   }
  // }, [clues]);

  // if(!clue) return null

  return (
    <div className={clsx(classes.Clues)}>
      {!(instance.currentClueIndex === instance.clues.length - 1 || instance.result) && 
      <div className={classes.button_ask}>
        <Button onClick={ () => instance.getNextClue()}
         >{Texts.get("qrl-ask-clue", {fallback: 'Demander un indice'})}</Button>
      </div>}

      {clue &&
      <div className={classes.clue}>
        {clue.Text}
      </div>}


      {clues.length > 0 &&
      <div className={classes.bullets}>
        {visibleClueIndex+  1}/{instance.clues.length}
        {/* {clues.map((c, index) =>
        <div
        key={c.ID}
        className={clsx(classes.bullet, index===visibleClueIndex && classes.active )}
        onClick={() => setVisibleClueIndex(index)} />)} */}
      </div>}

      {visibleClueIndex > 0 &&
        <Button
        className={classes.prevBtn}
        icon={<FaChevronLeft />}
        onClick={() => setVisibleClueIndex(i => i-1)}
        />}

        {visibleClueIndex < clues.length - 1 &&
        <Button
        className={classes.nextBtn}
        icon={<FaChevronRight />}
        onClick={() => setVisibleClueIndex(i => i+1)}
        />}
    </div>
  );
};

export default observer(Clues)
